import { UploadOutlined } from '@ant-design/icons';
import { Button, Input, Upload } from 'antd';
import React, { useState } from 'react';

import styles from './Message.module.scss';

const { TextArea } = Input;

interface MessageProps {
  onSend: (data: {
    message: string;
    fileData: string;
    fileName: string;
  }) => void;
  isLoading: boolean;
}

export const Message: React.FC<MessageProps> = ({ onSend, isLoading }) => {
  const [message, setMessage] = useState('');
  const [fileList, setFileList] = useState<any[]>([]);

  const handleFileChange = ({ fileList }: any) => {
    setFileList(fileList);
  };

  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleSend = async () => {
    let fileData = '';
    let fileName = '';

    if (fileList.length > 0) {
      const file = fileList[0].originFileObj;

      if (file) {
        const fileDataBase64 = await convertFileToBase64(file);
        fileData = fileDataBase64.split(',')[1];
        fileName = file.name;
      }
    }

    if (message.trim() || fileData) {
      onSend({ message, fileData, fileName });
      setMessage('');
      setFileList([]);
    }
  };

  return (
    <div className={styles.container}>
      <TextArea
        rows={4}
        style={{
          borderRadius: '8px',
          padding: '10px 10px 10px 15px',
          fontSize: '16px',
        }}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Введите сообщение"
      />
      <div className={styles.actions}>
        <Upload
          fileList={fileList}
          onChange={handleFileChange}
          beforeUpload={() => false}
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Прикрепить файл</Button>
        </Upload>

        <Button loading={isLoading} type="primary" onClick={handleSend}>
          Отправить
        </Button>
      </div>
    </div>
  );
};
